import { render, staticRenderFns } from "./Join2.vue?vue&type=template&id=13be5454&scoped=true&"
import script from "./Join2.vue?vue&type=script&lang=js&"
export * from "./Join2.vue?vue&type=script&lang=js&"
import style0 from "./Join2.vue?vue&type=style&index=0&id=13be5454&prod&lang=css&"
import style1 from "./Join2.vue?vue&type=style&index=1&id=13be5454&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be5454",
  null
  
)

export default component.exports